import React from 'react';
import { mockSharesRegister } from '../../../services/mockData';

const SharesRegister = () => (
  <div className="fade-in">
    <div className="page-header">
      <div className="breadcrumb">Registers <span>/ Shares Register</span></div>
      <h2>Shares Register</h2>
    </div>

    <div className="card">
      <div className="card-header">
        <span className="card-title">Shares Report</span>
        <button className="btn btn-warning btn-sm">🖨️ Print</button>
      </div>

      <div className="report-header" style={{ marginBottom: '16px' }}>
        <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
        <p>Registration Number: TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
        <p style={{ fontWeight: '700', marginTop: '6px' }}>Shares Register 2025-2026 On dated: 2026-02-02</p>
      </div>

      <div className="table-wrapper">
        <table>
          <thead>
            <tr>
              <th>S.No</th>
              <th>Date of Allotment of Share</th>
              <th>Cash Book Folio</th>
              <th>Share Certificate No.</th>
              <th>No. of Shares</th>
              <th>Value (₹)</th>
              <th>Name of Member to Whom Shares Are Allotted</th>
              <th>Date of Transfer</th>
              <th>Share Cert No. Transferred</th>
              <th>Value of Shares Transferred</th>
              <th>Name of Transferee</th>
            </tr>
          </thead>
          <tbody>
            {mockSharesRegister.map((s, i) => (
              <tr key={i}>
                <td>{s.srNo}</td>
                <td>{s.dateAllotment}</td>
                <td>{s.cashBookFolio}</td>
                <td style={{ fontWeight: '600' }}>{s.shareCertificateNo}</td>
                <td>{s.noOfShares}</td>
                <td className="amount">{s.value}</td>
                <td>{s.nameOfMember}</td>
                <td>{s.dateTransferred}</td>
                <td>{s.shareCertTransferred || '—'}</td>
                <td>{s.valueTransferred || '—'}</td>
                <td>{s.nameTransferee || '—'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
);

export default SharesRegister;
